import { Flex, Table, Tag } from "antd";
import React, { useState } from "react";
import Title from "antd/es/typography/Title";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../common/spinner/Spinner";
import { appConstConfig } from "../../../../../constants/config/appConstConfig";
import useDebounce from "../../../../../hooks/useDebounce";
import { getSentOrganizationPushNotificationListAction } from "../../../../../redux/services/push-notification/pushNotificationServices";
import { dateObjToDispViewDate, timeObjToDispViewTimeWithSuffix } from "../../../../../utils/utils";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { colors } from "../../../../../constants/colors";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.guess();

const SentPushNotificationList = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { sentPushNotifications } = useSelector((state) => state.pushNotification);
  const [searchValue] = useState("");
  const { debouncedValue: debouncedSearchValue } = useDebounce(
    searchValue,
    500
  );
  const [pagination, setPagination] = useState({
    pageNo: appConstConfig.DEFAULT_TABLE_PAGE_NUMBER,
    pageSize: appConstConfig.DEFAULT_TABLE_PAGE_SIZE,
  });

  
  const paginationObj = {
    total: sentPushNotifications?.total,
    current: pagination?.pageNo,
    pageSize: pagination?.pageSize,
    onChange: (pageNo, pageSize) => setPagination({ pageNo, pageSize }),
    pageSizeOptions: appConstConfig.DEFAULT_PAGE_SIZE_OPTIONS_ARR,
    showSizeChanger: true,
  };
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {
      page: debouncedSearchValue !== "" ? 1 : pagination?.pageNo,
      limit: pagination?.pageSize,
      search: debouncedSearchValue,
    }
    dispatch(getSentOrganizationPushNotificationListAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, [pagination, debouncedSearchValue]);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("Modules.Notify.title"),
        dataIndex: "title",
        key: "title",
        render: (_, record) => <div
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "200px",
          overflow: "hidden",
        }}>
        {record?.title || ""}
      </div>,
      },
      {
        title: t("Modules.Notify.description"),
        dataIndex: "message",
        render: (_, record) => <div
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "200px",
          overflow: "hidden",
        }}
      >
        {record?.message || ""}
      </div>,
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        render: (_, record) => (
          <p>{`${dateObjToDispViewDate(record?.created_at, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.created_at).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`}</p>
        ),
      },
      {
        title: t("scheduledAt"),
        dataIndex: "schedule_date_time",
        render: (_, record) => (
          <p>{record?.schedule_date_time ? `${dateObjToDispViewDate(record?.schedule_date_time, "ddmmyyyy")} - ${timeObjToDispViewTimeWithSuffix(dayjs
              .utc(record?.schedule_date_time).local().tz(dayjs.tz.guess()).format("YYYY-MM-DDTHH:mm:ss")
          )}`:' - '}</p>
        ),
      },
      {
        title: t("Modules.AutoCredit.status"),
        dataIndex: "status",
        key: "status",
        render: (_, { status }) => (
          <Tag
            key={status}
            style={{
              background: status === "Scheduled"
                ? colors.lightPastelBlue
                : colors.darkGoldenRod,
              color: status === "Scheduled" ? colors.electricBlue : colors.mango,
            }}
            bordered={false}
          >
            {status?.toUpperCase()}
          </Tag>
        ),
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */


  return (
    <div className="sentPushNotificationListContainer">
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Title level={2}>{t("sentNotifications")}</Title>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table dataSource={sentPushNotifications?.data} columns={columns} pagination = {paginationObj} />
        )}
      </Flex>
    </div>
  );
};

export default SentPushNotificationList;
